const getters = {
  component: (state) => state.component,
};

export default getters;
